// Queries Cloud Function to Save & Log Image

export default function SaveImage(guid, player, schema, options, callback) {
    const venueId = schema.chartType === 'field' ? options.venueId : ''
    const queryString = `guid=${guid}&chartType=${schema.chartType}&chartTypeCategory=${schema.chartTypeCategory}&chartSize=${schema.shape}&playerId=${player.playerId}&playerName=${player.playerName}&playerType=${player.playerType}&appType=${options.appType}&venueId=${venueId}`
    fetch(
        `https://us-central1-mlb-savant-sbx-617e.cloudfunctions.net/saveImage?${queryString}`
    ).then((response) => {
        response
            .blob()
            .then((blob) => {
                if (blob && blob.size > 1000) {
                    const url = window.URL.createObjectURL(blob)
                    const a = document.createElement('a')
                    a.href = url
                    a.download = `${guid}.jpg`
                    a.click()
                    callback()
                } else {
                    throw new Error('Error returning image.')
                }
            })
            .catch((err) => {
                callback(err)
            })
    })

    /* DownloadImage(playerType, schema, data, 'evp', (json) => {
        if (json) {
            callback(json)
        }
        else {
            callback();
        }
    }); */
}
